import type { SettingsMenuContainer } from '../settings-menu-container'

import { register } from '|>/shared/vjs'
import { BaseMenu } from '../../base'
import { SettingsMainMenuAudioItem } from './settings-main-menu-audio-item'
import { SettingsMainMenuQualityItem } from './settings-main-menu-quality-item'
import { SettingsMainMenuSubtitlesItem } from './settings-main-menu-subtitles-item'

/**
 * Settings main menu with audio and subtitles items
 */
@register
export class SettingsMainMenu extends BaseMenu {
  declare container: SettingsMenuContainer | undefined

  // menu items
  declare audioItem: SettingsMainMenuAudioItem
  declare subtitlesItem: SettingsMainMenuSubtitlesItem
  declare qualityItem: SettingsMainMenuQualityItem

  update() {
    this.audioItem.update()
    this.subtitlesItem.update()
    this.qualityItem.update()
    this.audioItem.container = this.container
    this.subtitlesItem.container = this.container
    this.qualityItem.container = this.container
  }

  activate() {
    this.addClass('vjs-x-active')
  }

  deactivate() {
    this.removeClass('vjs-x-active')
  }
}

SettingsMainMenu.options = {
  className: 'vjs-x-settings-main-menu vjs-menu',
  children: [
    // quality menu item
    SettingsMainMenuQualityItem.as('qualityItem'),

    // subtitles menu item
    SettingsMainMenuSubtitlesItem.as('subtitlesItem'),

    // audio menu item
    SettingsMainMenuAudioItem.as('audioItem'),
  ],
}
